export class Perfil {
    idperfil!: number;dsperfil!: string;flstatus!: boolean;dtalteracao!: Date;dtcriacao!: Date;
}

